<div class="app-layout">
  <app-topbar *ngIf="!layout.fullscreen()"></app-topbar>

  <div class="app-body" [class.fullscreen]="layout.fullscreen()">
    <app-sidebar *ngIf="!layout.fullscreen() && !layout.hideSidebar()"></app-sidebar>

    <main class="app-content" [class.fullscreen]="layout.fullscreen()">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<ng-container *ngIf="alerts.activeAlertView$ | async as alert">
  <app-modal
    [open]="!!alert"
    [variant]="'danger'"
    [title]="alert.title"
    [message]="alert.message"
    [highlight]="alert.highlight"
    primaryText="Alerta resolvida"
    secondaryText="Fechar"
    (primary)="resolveAlertModal()"
    (secondary)="closeAlertModal()"
    (close)="closeAlertModal()"
  >
    <div class="alert-observation">
      <label for="alert-observation">Observação (opcional)</label>
      <textarea
        id="alert-observation"
        rows="3"
        [value]="alertObservation"
        (input)="onObservationInput($event)"
        placeholder="Descreva a resolução ou observações do alerta"
      ></textarea>
    </div>
  </app-modal>
</ng-container>
